import { TRANSLATION_PORTAL, translationCatalogueSchema } from '@contracts/translations'
import type { HttpClient } from '@/shared/api'

export function createTranslationsApi(http: HttpClient) {
  return {
    /**
     * The interface texts in one language. Public: the sign-in page needs them before a session
     * exists. The language is sent explicitly so the request never depends on the store.
     */
    catalogue: (language: string, signal?: AbortSignal) =>
      http.get(`/translations/${TRANSLATION_PORTAL}`, {
        schema: translationCatalogueSchema,
        headers: { 'X-Language': language },
        auth: false,
        signal,
      }),
  }
}
